import { render, staticRenderFns } from "./AdyenCreateOrderPaymentSection.vue?vue&type=template&id=126e85d0"
import script from "./AdyenCreateOrderPaymentSection.vue?vue&type=script&lang=js"
export * from "./AdyenCreateOrderPaymentSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports